import {ControllerParams} from '@wix/yoshi-flow-editor';

export function getFormattingFunction({
  flowAPI,
  formatingCurrency,
}: {
  flowAPI: ControllerParams['flowAPI'];
  formatingCurrency: string;
}) {
  const createCurrencyFormatter = flowAPI.essentials.createCurrencyFormatterWithDefaults({
    language:
      flowAPI.controllerConfig.wixCodeApi.window.multilingual.currentLanguage ||
      flowAPI.controllerConfig.wixCodeApi.site.regionalSettings ||
      'en-US',
  });
  const formatCurrency = createCurrencyFormatter();
  return (amount: string | number) => formatCurrency({value: amount, currency: formatingCurrency || 'USD'});
}
